<template>
  <div class="xiaobu-container" v-closeSelect="'window'">
    <el-form ref="queryForm" :model="queryParams" :inline="true" class="search-form clearfix">
      <el-form-item class="search-field fl five-per-row" label="出库单号" prop="outNo">
        <el-input v-model.trim="queryParams.outNo" placeholder="请输入出库单号" clearable @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="入库仓库" prop="wareHouseId">
        <el-cascader aria-hidden="false" :options="wareHouseData" clearable :props="defaultProps"
          v-model="queryParams.wareHouseId" @change="handleQuery" placeholder="请选择入库仓库" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="出库类型" prop="outType">
        <el-select-dict dictType="OUT_TYPE" clearable placeholder="请选择出库类型" v-model="queryParams.outType"
          @dictChange="handleQuery"></el-select-dict>
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="客户姓名" prop="customerName">
         <el-input v-model.trim="queryParams.customerName" placeholder="请输入客户姓名" clearable
          @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="出库状态" prop="outStatus">
        <el-select-dict dictType="OUT_STATUS" clearable placeholder="请选择出库状态" v-model="queryParams.outStatus"
          @dictChange="handleQuery"></el-select-dict>
      </el-form-item>

      <el-form-item class="search-field fl" label="渠道" prop="channel">
        <el-select-dict dictType="CHANNEL" clearable placeholder="请选择渠道" v-model="queryParams.channel"
          @change="handleQuery"></el-select-dict>
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="创建时间" prop="beginTime">
        <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" @change="handleQuery"
          range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item class="fr">
        <el-button plain @click="resetQuery">重 置</el-button>
        <el-button type="primary" @click="handleQuery">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <div class="table-control-box">
        <el-button v-hasPermission="['inventory:out:create']" type="primary" plain icon="el-icon-plus" size="mini"
          @click="handleAdd">新增</el-button>
        <el-button v-hasPermission="['inventory:out:update']" type="success" plain icon="el-icon-edit" size="mini"
          :disabled="single" @click="handleUpdate">编辑</el-button>
        <el-button v-hasPermission="['inventory:out:delete']" type="danger" plain icon="el-icon-delete" size="mini"
          :disabled="multiple" @click="handleBatchDelete">删除</el-button>
      </div>
      <div class="table-box">
        <auto-height-table ref="outTable" :class="{ empty: list.length === 0 }" empty-text=" " v-loading="loading" :data="list"
          row-key="outId" @selection-change="handleSelectionChange" @row-click="clickRow">
          <el-table-column type="selection" :selectable="checkSelectable" :reserve-selection="true" width="55"
            align="center" />
          <el-table-column label="出库单号" prop="outNo" align="center" min-width="168px" >
            <template slot-scope="scope">
              <el-link v-if="mixinHasPermi(['inventory:record:list']) && scope.row.outStatus === '1'" type="primary" @click="mixinHandleGoRecordList(scope.row.outNo)">{{ scope.row.outNo }}</el-link>
              <span v-else>{{ scope.row.outNo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="出库仓库" prop="wareHouseIdList" align="center" min-width="168px" show-overflow-tooltip="">
            <template slot-scope="scope">
              <span>{{ getWareHouseNameByList(scope.row.wareHouseIdList) }}</span>
            </template>
          </el-table-column>
          <el-table-column-dict dictType="OUT_TYPE" label="出库类型" prop="outType" align="center" min-width="120px" />
          <el-table-column label="客户姓名" prop="customerName" align="center" min-width="156px" show-overflow-tooltip />
          <el-table-column-dict dictType="OUT_STATUS" dictTypeNode="tag" label="出库状态" align="center" prop="outStatus"
            min-width="100px"></el-table-column-dict>
          <el-table-column-dict dictType="CHANNEL" dictTypeNode="tag" label="渠道" align="center" prop="channel"
            min-width="100px"></el-table-column-dict>
          <el-table-column label="操作人" prop="creator.userName" align="center" min-width="168px" show-overflow-tooltip>
            <template slot-scope="scope">
              创建人：{{ scope.row.creator.userName }}<br />
              更新人：{{ scope.row.updater.userName }}
            </template>
          </el-table-column>
          <el-table-column dateFormat="datetime" label="操作时间" align="center" prop="createTime" min-width="256px">
            <template slot-scope="scope">
              创建时间：{{ scope.row.createTime | formatDate("datetime") }}<br />
              更新时间：{{ scope.row.updateTime | formatDate("datetime") }}
            </template>
          </el-table-column>
          <el-table-column v-if="
            mixinHasPermi([
              'inventory:out:read',
              'inventory:out:delete',
            ])
          " label="操作" align="center" width="228px" fixed="right" class-name="small-padding ">
            <template slot-scope="scope">
              <el-button size="mini" v-hasPermission="['inventory:out:read']" type="primary" icon="el-icon-view"
                @click.native.stop="handleUpdate(scope.row)">查看</el-button>
              <el-button :disabled="scope.row.outStatus === '1'" v-hasPermission="['inventory:out:read']" size="mini"
                type="danger" icon="el-icon-delete" title="已出库的出库单不可删除"
                @click.native.stop="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </auto-height-table>

        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize" @pagination="getList" />
      </div>
    </div>
    <out-dialog ref="outDialog" :visible.sync="open" :modal-append-to-body="false" :close-on-click-modal="false"
      :isUpdate="isUpdate" :baseForm="baseForm" @close="open = false" @successs="init" :wareHouseData="wareHouseData" width="1280px"></out-dialog>
  </div>
</template>

<script>
import OutDialog from "./components/out-dialog.vue"
import { outApi, wareHouseApi } from "@/api"
import {markNonLeafNodes} from "@/utils/tree"
import { getPathByTreeValue } from "vue2-element-admin-plugin"
export default {
  name: "inventoryOutManage",
  components: {
    OutDialog
  },
  data() {
    return {
      wareHouseData: [], // 仓库树 数据
      defaultProps: {
        checkStrictly: true,
        value: "wareHouseId",
        children: "children",
        label: "wareHouseName"
      },
      selection: [], // 选中的列表数据
      // 非单个禁用
      single: true,
      // 非多个禁用(0个禁用)
      multiple: true,
      isUpdate: false, // 是否是编辑
      //搜索条件参数
      queryParams: {
        outNo: "", // 出库单号
        wareHouseId: "", // 入库仓库
        outType: "", // 出库类型 
        customerName: "", // 客户姓名
        outStatus: "", // 配置项状态
        channel: "", // 渠道
        beginTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10
      },
      dateRange: [],
      list: [],
      loading: false,
      total: 0,
      open: false,
      // 表单参数
      baseForm: {
        outType: "", // 
        outStatus: "", // 
        customerId: "", // 客户id
        customerName: "", // 客户名称
        spuListJson: "", // spu列表
        outSumNumber: "", //合计入库数量
        outSumCostPrice: "", // 合计出库成本金额
        outSumSalesPrice: "", // 合计出库销售金额
        remark: "" // 备注
      }

    }
  },
  watch: {
    open(val) {
      if (!val) {
        this.isUpdate = false
        this.baseForm = {
          outType: "", // 
          outStatus: "", // 
          customerId: "", // 客户id
          customerName: "", // 客户名称
          spuListJson: "", // spu列表
          outSumNumber: "", //合计入库数量
          outSumCostPrice: "", // 合计出库成本金额
          outSumSalesPrice: "", // 合计出库销售金额
          remark: "" // 备注
        }
        this.$refs.outDialog && this.$refs.outDialog.resetForm()
      }
    }
  },
  async created() {
    const { query } = this.$route
    if (query.operateNo || query.billNo || query.outNo) {
      this.queryParams.outNo = query.operateNo || query.billNo || query.outNo
    }
    await this.init()
  },
  methods: {
    // 初始化
    async init() {
      await this.getWareHouseTree()
      //获取列表
      this.getList()
    },
    // 通过仓库id数组 返回仓库名字
    getWareHouseNameByList(wareHouseIdList) {
      const wareHouseNameList = []
      for (let i = 0; i < wareHouseIdList.length; i++) {
        const wareHouseId = wareHouseIdList[i]
        const name = this.getWareHouseName(wareHouseId)
        wareHouseNameList.push(name)
      }
      return wareHouseNameList.join("；")
    },
    // 获取仓库名字
    getWareHouseName(val) {
      if (!val) {
        return ""
      }
      const wareHouseId = Array.isArray(val) ? val[val.length - 1] : val
      const list = getPathByTreeValue(this.wareHouseData, wareHouseId, { targetField: "wareHouseId", childrenField: "children" }, true)
      return list[list.length - 1].labelArr.join("/")
    },
    // 获取仓库列表
    getWareHouseTree() {
      return wareHouseApi.getWareHouseTree().then((data) => {
        this.wareHouseData = markNonLeafNodes(data, this.$store.getters.wareHouseIdList, {idField: "wareHouseId"})
      })
    },
    //批量删除
    handleBatchDelete() {
      // 让按钮返回原样
      this.mixinBtnBlur()

      let str = ""
      const ids = []
      for (let i = 0; i < this.selection.length; i++) {
        const item = this.selection[i]
        ids.push(item.outId)
        str += item.outNo
        if (i !== this.selection.length - 1) {
          str += ", "
        }
      }
      this.$modal
        .confirm('删除后将无法找回！是否确认删除出库单号为"【' + str + '】"的数据项？')
        .then(function() {
          return outApi.batchDeleteItems({ ids })
        })
        .then(() => {
          this.handleQuery()
          this.$modal.msgSuccess("批量删除出库单成功")
        })
    },
    // 已出库的 禁止操作
    checkSelectable(row, index) {
      if (row.outStatus === "1") {
        return false
      } else {
        return true
      }
    },
    //点击行
    clickRow(row) {
      //已入库的 不做处理
      if (row.outStatus === "1") {
        return
      }
      this.$refs.outTable.toggleRowSelection(row)
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.selection = selection
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.mixinResetForm("queryForm")
      // 库存单号重置
      this.queryParams.outNo = ""
      this.handleQuery()
    },
    /** 查询列表 */
    getList() {
      // 清空所有选中的数据
      this.$refs.outTable && this.$refs.outTable.clearSelection()
      this.loading = true
      const params = JSON.parse(JSON.stringify(this.queryParams))
      params.wareHouseId = (Array.isArray(params.wareHouseId) ? params.wareHouseId[params.wareHouseId.length - 1] : params.wareHouseId) || null
      outApi
        .getList(this.mixinAddDateRange(params, this.dateRange))
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          this.loading = false
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.open = true
    },

    /** 编辑按钮操作 */
    handleUpdate(row) {
      if (!row.outId) {
        this.isUpdate = true
      }
      const id = row.outId || (this.selection[0] && this.selection[0].outId)
      outApi.getDetailById({ id }).then((data) => {
        this.baseForm = Object.assign(this.baseForm, data)
        this.open = true
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      // 让按钮返回原样
      this.mixinBtnBlur()
            
      const id = row.outId
      this.$modal
        .confirm('删除后将无法找回！是否确认删除出库单号为"' + row.outNo + '"的数据项？')
        .then(function() {
          return outApi.deleteItem({ id })
        })
        .then(() => {
          this.handleQuery()
          // 判断删除的项是否被勾选了
          const flag = this.selection.find((item) => item.outId === id)
          flag && this.$refs.outTable.toggleRowSelection(row, false)
          this.$modal.msgSuccess("删除成功")
        })
    }
  }
}
</script>